module.exports = __webpack_public_path__ + "img/picto-search.abd0618b.svg";